import Vue from "vue";
import * as types from "./mutation-types";

const challengesMutations = {
  [types.SET_CHALLENGES](state, challenges) {
    state.challenges = challenges;
  },

  [types.SET_ARCHIVED_CHALLENGES](state, archivedChallenges) {
    state.archivedChallenges = archivedChallenges;
  },

  [types.SET_CHALLENGES_BY_MEMBER_ID](state, data) {
    state[data.key] = data.value;
  },

  [types.ADD_CHALLENGE](state, challenge) {
    state.challenges.push(challenge);
    state.challenges = Vue._.uniqBy(state.challenges, "id");
  },

  [types.ADD_TEAM](state, team) {
    state.memberTeams.push(team);
  },

  [types.SET_CHALLENGE_INVITES](state, invites) {
    state.challengeInvites = invites;
  },

  [types.SET_MEMBER_FRIENDS](state, friends) {
    state.memberFriends = friends;
  },

  [types.SET_FRIENDS_REQUESTING](state, friendsRequesting) {
    state.friendsRequesting = friendsRequesting;
  },

  [types.SET_FRIENDS_INVITED](state, friendsInvited) {
    state.friendsInvited = friendsInvited;
  },

  [types.SET_MOBILE_CHALLENGES](state, challenges) {
    state.mobileChallenges = challenges;
  }
};

const memberMutations = {
  [types.SET_MEMBER](state, member) {
    state.member = member;
    state.memberCopy = Vue._.cloneDeep(member);
  },

  [types.SET_MEMBER_BADGES](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_LOADED_BADGES](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_MEMBER_BY_NAME](state, data) {
    state[data.key] = data.value;
  },

  [types.UPDATE_MEMBER_COPY_VALUE](state, data) {
    if (data.subKey) {
      state.memberCopy[data.key][data.subKey] = data.value;
    } else {
      state.memberCopy[data.key] = data.value;
    }
  },

  [types.UPDATE_MEMBER_VALUE](state, data) {
    state.member[data.key] = data.value;
  },

  [types.SET_STEP_DATA](state, stepData) {
    state.stepData = stepData;
  },
  [types.SET_METRIC_DATA](state, stepData) {
    state.stepData = stepData;
  },
  [types.SET_WELLNESS_CHART_DATA](state, wellnessChartData) {
    state.wellnessChartData = wellnessChartData;
  },

  [types.SET_STEP_DATA_BY_MEMBER_ID](state, data) {
    state[data.key] = data.value;
  },
  [types.SET_METRIC_DATA_BY_MEMBER_ID](state, data) {
    state[data.key] = data.value;
  },

  [types.RESET_JOURNALS](state) {
    state.journals = [];
  },

  [types.IS_JOURNAL_LAST_PAGE](state, isLastPage) {
    state.isJournalLastPage = isLastPage;
  },

  [types.SET_JOURNALS](state, journals) {
    if (Array.isArray(journals)) {
      state.journals.push(...journals);
    } else {
      state.journals = journals;
    }
  },

  [types.SET_JOURNAL_ENTRY_STATS](state, stats) {
    state.journalEntryStats = stats;
  },

  [types.SET_MAKE_AN_ENTRY_JOURNAL](state, makeAnEntryJournal) {
    state.makeAnEntryJournal = makeAnEntryJournal;
  },

  [types.SET_JOURNAL_PAGE_JOURNAL](state, journalPageJournal) {
    state.journalPageJournal = journalPageJournal;
  },

  [types.RESET_JOURNALS_BY_MEMBER_ID](state, key) {
    state[key] = [];
  },

  [types.SET_JOURNALS_BY_MEMBER_ID](state, data) {
    if (state[data.key] === undefined) {
      state[data.key] = data.value;
    } else {
      state[data.key].push(...data.value);
    }
  },

  [types.SET_ACTIVITIES](state, activities) {
    state.activities = activities;
  },

  [types.SET_MILESTONES](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_LEADERBOARD_BY_MEMBER_ID](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_DEVICE_API](state, data) {
    state.deviceApi = data.value;
  }
};

const teamMutations = {
  [types.SET_MEMBER_TEAMS](state, teams) {
    state.memberTeams = teams;
  },

  [types.SET_MEMBER_TEAMS_ADMIN](state, teams) {
    state.teamsMemberIsAdmin = teams;
  },

  [types.UPDATE_MEMBER_TEAM](state, team) {
    const index = Vue._.findIndex(state.memberTeams, { id: team.id });
    if (index > -1) {
      state.memberTeams.splice(index, 1, team);
    }
  },

  [types.UPDATE_TEAMS_MEMBER_IS_ADMIN](state, team) {
    const index = Vue._.findIndex(state.teamsMemberIsAdmin, { id: team.id });
    if (index > -1) {
      state.teamsMemberIsAdmin.splice(index, 1, team);
    }
  },

  [types.SET_TEAMS_BY_MEMBER_ID](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_MEMBER_TEAM_INVITES](state, invites) {
    state.memberTeamInvites = invites;
  },

  [types.SET_MEMBER_FRIENDS_LOADED_STATUS](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_MEMBER_FRIENDS_BY_MEMBER_ID](state, data) {
    state[data.key] = data.value;
  }
};

const messageMutations = {
  [types.SET_MESSAGES](state, messages) {
    state.messages = messages;
  },

  [types.SET_JOIN_REQUEST_MESSAGES](state, messages) {
    state.joinRequestMessages = messages;
  },

  [types.SET_MESSAGE_COUNT](state, count) {
    state.messageCount = count;
  }
};

const noticeMutations = {
  [types.SET_MEMBER_NOTICE](state, memberNotice) {
    state.memberNotice = memberNotice;
  },

  [types.SET_MEMBER_ORGANIZATION_NOTICE](state, notice) {
    state.memberOrganizationNotice = notice;
  }
};

const mutations = {
  [types.SET_LOADED_STATUS](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_LOADING_STATUS](state, data) {
    state[data.key] = data.value;
  }
};

Object.assign(
  mutations,
  challengesMutations,
  memberMutations,
  teamMutations,
  messageMutations,
  noticeMutations
);

export default mutations;
